import { MESSAGE_TYPE } from 'shared/constants/messages';
import { isMessageFromCurrentUser } from 'dashboard/helper/AudioAlerts/AudioMessageHelper';
import WindowVisibilityHelper from 'dashboard/helper/AudioAlerts/WindowVisibilityHelper';
import { frontendURL } from 'dashboard/helper/URLHelper';
import GlobalStore from 'dashboard/store';

const NOTIFICATION_ICON = '/brand-assets/logo.png';
const MAX_BODY_LENGTH = 100;

export class WebNotificationHelper {
  constructor(store) {
    if (!store) {
      throw new Error('store is required');
    }
    this.store = store;
    this.currentUser = null;
  }

  set = ({ currentUser }) => {
    this.currentUser = currentUser;
  };

  isSupported = () => 'Notification' in window;

  hasPermission = () =>
    this.isSupported() && Notification.permission === 'granted';

  shouldNotify = message => {
    if (!this.hasPermission()) return false;
    if (!this.currentUser) return false;
    if (isMessageFromCurrentUser(message, this.currentUser.id)) return false;

    const { message_type: messageType, private: isPrivate } = message;
    if (messageType !== MESSAGE_TYPE.INCOMING && !isPrivate) return false;

    // Don't show if window is focused and user is already viewing this conversation
    if (WindowVisibilityHelper.isWindowVisible()) {
      const selectedChatId = this.store.getters.getSelectedChat?.id;
      if (selectedChatId === message.conversation_id) return false;
    }

    return true;
  };

  buildNotificationBody = message => {
    if (message.content) {
      return message.content.length > MAX_BODY_LENGTH
        ? `${message.content.slice(0, MAX_BODY_LENGTH)}…`
        : message.content;
    }
    if (message.attachments?.length) return 'Sent an attachment';
    return '';
  };

  onNewMessage = message => {
    if (!this.shouldNotify(message)) return;

    const { sender, conversation_id: conversationId } = message;
    const accountId = this.store.getters.getCurrentAccountId;

    const notification = new Notification(sender?.name || 'New message', {
      body: this.buildNotificationBody(message),
      icon: sender?.avatar_url || NOTIFICATION_ICON,
      tag: `cw-msg-${conversationId}`,
      silent: true, // audio is handled by DashboardAudioNotificationHelper
    });

    notification.onclick = () => {
      window.focus();
      window.location.href = frontendURL(
        `accounts/${accountId}/conversations/${conversationId}`
      );
      notification.close();
    };
  };
}

export default new WebNotificationHelper(GlobalStore);
